import FilePreview from './Index.vue'

FilePreview.install = function(Vue) {
    Vue.component(FilePreview.name, FilePreview)
}

export default FilePreview
